import { useMemo } from "react";
import MonitorOutlinedIcon from "@mui/icons-material/MonitorOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import ContentPasteSearchOutlinedIcon from "@mui/icons-material/ContentPasteSearchOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";

import { paths } from "src/paths";
import { useAuth } from "src/hooks/use-auth";

export const useSections = () => {
  const { user } = useAuth();

  return useMemo(() => {
    return [
      {
        items: [
          {
            title: "모니터링",
            path: paths.dashboard.monitoring,
            icon: <MonitorOutlinedIcon fontSize="small" />,
          },
          {
            title: "처리 통계",
            path: paths.dashboard.statistics,
            icon: <TableChartOutlinedIcon fontSize="small" />,
          },
          {
            title: "문서 조회",
            path: paths.dashboard.documents,
            icon: <ContentPasteSearchOutlinedIcon fontSize="small" />,
          },
          {
            title: "데이터 추출",
            path: paths.dashboard.export,
            icon: <InsertChartOutlinedIcon fontSize="small" />,
          },
          ...(user?.role === "super" || user?.role === "admin"
            ? [
                {
                  title: "사용자 관리",
                  path: paths.dashboard.users,
                  icon: <ManageAccountsOutlinedIcon fontSize="small" />,
                },
                {
                  title: "설정",
                  path: paths.dashboard.settings,
                  icon: <SettingsOutlinedIcon fontSize="small" />,
                },
              ]
            : []),
        ],
      },
    ];
  }, [user?.role]);
};
